export const BANNER_IMAGE_FILE_ADDRESS_COMBINED_PATH =
    '/assets/website/ap-connect-banner-2023/category-images-combined/';

export const CATEGORY_IMAGE_COMBINED = 'ap-connect-profiles-full-desktop.png';

export const AP_CONNECT_BANNER_TITLE = `Let ARCHIPRO find a professional for you`;

export const AP_CONNECT_BANNER_DESCRIPTION = `
    Tell us about your project and we'll match you with 
    the best professionals suited to your project and budget
`;

export const AP_CONNECT_TYPEFORM_ID = 's44llL80';
